export const storageKeys = {
    LLM_API_URL: 'LLM_API_URL', // API URL for interacting with the LLM
    LLM_MODEL: 'LLM_MODEL', // Selected LLM model
    LLM_RESPONSE_TEMPERATURE: 'LLM_RESPONSE_TEMPERATURE', // Response randomness level for LLM
    LLM_SYSTEM_INSTRUCTIONS: 'LLM_SYSTEM_INSTRUCTIONS', // Instructions for the system to the LLM
    LLM_USER_INSTRUCTIONS: 'LLM_USER_INSTRUCTIONS', // Instructions from the user to the LLM
    ADDITIONAL_LLM_OPTIONS: 'ADDITIONAL_LLM_OPTIONS', // Additional LLM options
    USE_TOOLS_CALLS: 'USE_TOOLS_CALLS', // Whether to use tools calls
    SCHEMA_PROPERTIES: 'SCHEMA_PROPERTIES', // Schema properties checklist
    CHECKERS: 'CHECKERS', // List of checkers to be used
    CHECKERS_REGISTRY_BASEURL: 'CHECKERS_REGISTRY_BASEURL',
    CHECKERS_RESULTS_MAPPING : 'CHECKERS_RESULTS_MAPPING',
    SHOW_CHECKERS_WARNINGS: 'SHOW_CHECKERS_WARNINGS', // Whether to show checkers warnings
    SESSION_ID: 'SESSION_ID', // Unique session identifier
    BPMN_TRANSLATOR_SERVICE_URL: 'BPMN_TRANSLATOR_SERVICE_URL', // URL for the BPMN translator service
    LLM_JSON_SCHEMA_SERVICE_URL: 'LLM_JSON_SCHEMA_SERVICE_URL', // URL for the LLM JSON schema service
    LLM_JSON_SCHEMA: 'LLM_JSON_SCHEMA', // LLM JSON schema
  };
  